"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./collectionPathwayInfoActionCard.scss");
const organization_svg_1 = __importDefault(require("../../../assets/images/fallbacks/organization.svg"));
const react_1 = __importStar(require("react"));
const react_linkedin_login_oauth2_1 = require("react-linkedin-login-oauth2");
const mail_icon_svg_1 = __importDefault(require("../../../assets/images/icons/mail-icon.svg"));
const verified_issuer_mark_svg_1 = __importDefault(require("../../../assets/images/icons/verified-issuer-mark.svg"));
const BaseButton_1 = __importDefault(require("../../../elementKit/baseButton/BaseButton"));
const x_svg_1 = __importDefault(require("../../../assets/images/socialIcons/x.svg"));
const facebook_svg_1 = __importDefault(require("../../../assets/images/socialIcons/facebook.svg"));
const whatsapp_svg_1 = __importDefault(require("../../../assets/images/socialIcons/whatsapp.svg"));
const yammer_svg_1 = __importDefault(require("../../../assets/images/socialIcons/yammer.svg"));
const linkedin_svg_1 = __importDefault(require("../../../assets/images/socialIcons/linkedin.svg"));
const xing_svg_1 = __importDefault(require("../../../assets/images/socialIcons/xing.svg"));
const three_dot_svg_1 = __importDefault(require("../../../assets/images/socialIcons/three-dot.svg"));
const react_share_1 = require("react-share");
const Linkedin_1 = require("../../../services/backend/Linkedin");
const CollectionPathwayInfoActionCardTranslations_json_1 = __importDefault(require("./collectionPathwayInfoActionCardTranslations/CollectionPathwayInfoActionCardTranslations.json"));
const CollectionPathwayInfoActionCardLoader_1 = __importDefault(require("./collectionPathwayInfoActionCardLoaders/CollectionPathwayInfoActionCardLoader"));
const react_detect_click_outside_1 = require("react-detect-click-outside");
const react_svg_1 = require("react-svg");
const styled_components_1 = __importDefault(require("styled-components"));
const master_1 = require("../../../constants/master");
const ElementBaseConfig_1 = require("../../../config/ElementBaseConfig");
const Notification_1 = __importDefault(require("../../../elementKit/notification/Notification"));
const react_toastify_1 = require("react-toastify");
const services_1 = require("../../../services");
const StyledCollectionPathwayInfoActionCard = styled_components_1.default.div `
  .more-div {
    border: 1px solid ${(props) => props.primaryColor} !important;

    .share-option {
      span {
        color: ${(props) => props.primaryColor} !important;
      }

      .customizable-icon .injected-svg {
        fill: ${(props) => props.primaryColor} !important;
        stroke: none !important;
      }
    }
  }
`;
function CollectionPathwayInfoActionCard(props) {
    var _a;
    props.addTranslation(CollectionPathwayInfoActionCardTranslations_json_1.default);
    const [shareDropdownOpen, setShareDropdownOpen] = react_1.default.useState(false);
    const twitterRef = react_1.default.useRef(null);
    const facebookRef = react_1.default.useRef(null);
    const xingRef = react_1.default.useRef(null);
    const whatsappRef = react_1.default.useRef(null);
    const yammerRef = react_1.default.useRef(null);
    const config = (0, master_1.getMasterConfig)();
    const toggleShareDropdown = () => {
        setShareDropdownOpen((prev) => !prev);
    };
    const triggerEvent = shareDropdownOpen ? toggleShareDropdown : () => { };
    const optimizedMixpanel = props.mixPanel
        ? new services_1.OptimizedMixPanel(props.mixPanel)
        : undefined;
    const moreRef = (0, react_detect_click_outside_1.useDetectClickOutside)({
        onTriggered: triggerEvent,
    });
    (0, react_1.useEffect)(() => {
        const linkedinAuthCode = new URLSearchParams(props.locationSearch).get("code");
        if (linkedinAuthCode) {
            props.setLinkedinAccessToken(linkedinAuthCode);
            handleLinkedinShare(linkedinAuthCode);
        }
    }, [props.locationSearch]);
    const handleMailTo = (type) => __awaiter(this, void 0, void 0, function* () {
        const baseMailTo = (0, ElementBaseConfig_1.getElementkitConfig)().baseMailTo;
        if (props.activeLanguage && props.organization) {
            if (type === "contactIssuer")
                if (props.activeLanguage.code === "tr")
                    window.open(`mailto:${props.organization.email}?subject=Sertifier | ${props.infoCardType === "collection"
                        ? "Sertifika Koleksiyonum Hakkında"
                        : "Sertifika Yolculuğum Hakkında"}&body=Merhaba,%0D%0A${window.location.href} linkindeki ${props.infoCardType === "collection" ? "koleksiyon" : "yolculuk"}la alakalı size ulaşıyorum. Aşağıda yer alan notum doğrultusunda düzeltme yapmanızı rica ederim.%0D%0A%0D%0A--%0D%0A%0D%0ASevgiler,`);
                else
                    window.open(`mailto:${props.organization.email}?subject=Sertifier | About My ${props.infoCardType === "collection" ? "Collection" : "Pathway"}&body=Hello,%0D%0AI'm reaching you about my ${props.infoCardType === "collection" ? "collection" : "pathway"}. You can access the ${props.infoCardType === "collection" ? "collection" : "pathway"} via ${window.location.href}. Can you please take into my note attached below.%0D%0A%0D%0A--%0D%0A%0D%0ARegards,`);
            if (type === "report")
                if (props.activeLanguage.code === "tr")
                    window.open(`mailto:${baseMailTo}?subject=${props.infoCardType === "collection"
                        ? "Koleksiyon Sorunu"
                        : "Pathway Sorunu"}&body=Merhaba, %0D%0A%0D%0A${window.location.href} linkindeki ${props.infoCardType === "collection" ? "koleksiyon" : "yolculuk"}la alakalı sorunumu sizinle aşağıda paylaşıyorum. Konunun herhangi isim değişikliği veya ${props.infoCardType === "collection" ? "koleksiyon" : "yolculuk"} içeriğiyle alakalı olmadığını doğrularım.%0D%0A%0D%0ASevgiler,`);
                else
                    window.open(`mailto:${baseMailTo}?subject=${props.infoCardType === "collection"
                        ? "Collection Issue"
                        : "Pathway Issue"}&body=Hello, %0D%0AI’m sharing with you my issue with my ${props.infoCardType === "collection" ? "collection" : "pathway"}. You can access the ${props.infoCardType === "collection" ? "collection" : "pathway"} via ${window.location.href}. I acknowledge this email is not related to any issue regarding the name or details located on the ${props.infoCardType === "collection" ? "collection" : "pathway"}.%0D%0A%0D%0ARegards,`);
            if (type === "reportNotFound")
                if (props.activeLanguage.code === "tr")
                    window.open(`mailto:${baseMailTo}?subject=${props.infoCardType === "collection"
                        ? "Koleksiyon Bulunamadı Sorunu"
                        : "Pathway Bulunamadı Sorunu"}&body=Merhaba, %0D%0A%0D%0A${window.location.href} adresindeki ${props.infoCardType === "collection" ? "koleksiyon" : "yolculuk"}umla alakalı sorunumu sizinle aşağıda paylaşıyorum.%0D%0A%0D%0ASevgiler,`);
                else
                    window.open(`mailto:${baseMailTo}?subject=${props.infoCardType === "collection"
                        ? "Collection Not Found Issue with address"
                        : "Pathway Not Found Issue with address"} ${window.location.href}&body=Hello, %0D%0AI’m sharing with you my issue with my ${props.infoCardType === "collection" ? "collection" : "pathway"}. You can access the ${props.infoCardType === "collection" ? "collection" : "pathway"} via ${window.location.href}.%0D%0A%0D%0ASevgiler,`);
        }
    });
    const handleDesc = (tag) => {
        const skillTags = (props.skills &&
            props.skills.reduce((tags, skill) => {
                return (tags += `#${skill.title
                    .toLocaleLowerCase()
                    .replace(/\s+/g, "")} `);
            }, "")) ||
            "";
        let via = "@" + (0, ElementBaseConfig_1.getElementkitConfig)().commonShareVia;
        if (tag === "linkedin") {
            via = (0, ElementBaseConfig_1.getElementkitConfig)().linkedinShareVia;
        }
        else if (tag === "facebook") {
            if (props.activeLanguage && props.activeLanguage.code === "tr")
                via = (0, ElementBaseConfig_1.getElementkitConfig)().facebookShareViaTr;
            else
                via = (0, ElementBaseConfig_1.getElementkitConfig)().facebookShareVia;
        }
        else if (tag === "twitter") {
            if (props.activeLanguage && props.activeLanguage.code === "tr")
                via = (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareViaTr;
            else
                via = (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareVia;
        }
        else
            via = (0, ElementBaseConfig_1.getElementkitConfig)().commonShareVia;
        if (props.activeLanguage && props.activeLanguage.code === "tr")
            return `${props.organization.name} tarafından ${via} aracılığıyla verilen Verified ${props.infoCardType === "collection" ? "koleksiyon" : "yolculuk"}uma göz at!\n${skillTags}\n`;
        else
            return `Check out my verified ${props.infoCardType === "collection" ? "collection" : "pathway"} issued by ${props.organization.name} via ${via}!\n${skillTags}\n`;
    };
    const shareOnYammer = () => {
        handleClick("yammer");
        window.yam.platform.yammerShareOpenPopup({
            defaultMessage: handleDesc("yammer"),
            pageUrl: window.location.href,
        });
    };
    const handleClick = (sharingFor) => __awaiter(this, void 0, void 0, function* () {
        const typeText = props.infoCardType === "collection"
            ? "Collection Share"
            : "Pathway Share";
        const mixpanelBody = props.infoCardType === "collection"
            ? {
                collection_id: props.collectionPathwayId,
                sharingFor: sharingFor,
                isLogged: props.userMeta.logged,
            }
            : {
                pathway_id: props.collectionPathwayId,
                sharingFor: sharingFor,
                isLogged: props.userMeta.logged,
            };
        optimizedMixpanel === null || optimizedMixpanel === void 0 ? void 0 : optimizedMixpanel.track(typeText, mixpanelBody);
    });
    const handleLinkedinShare = (code) => __awaiter(this, void 0, void 0, function* () {
        try {
            const tokenCode = yield (0, Linkedin_1.getLinkedInAccessToken)(code, props.linkedinRedirectUri);
            if (!tokenCode) {
                (0, Notification_1.default)({
                    type: "error",
                    text: props.translate("linkedinError").toString(),
                });
                return;
            }
            props.setLinkedinAccessToken(tokenCode);
            const userId = yield (0, Linkedin_1.getLinkedInUserIdProxy)(tokenCode);
            if (!userId) {
                (0, Notification_1.default)({
                    type: "error",
                    text: props.translate("linkedinError").toString(),
                });
                return;
            }
            props.setLinkedinUserId(userId);
            props.openLinkedinDialog();
        }
        catch (error) {
            console.log("unhandled error", error);
        }
    });
    return props.loading ? (react_1.default.createElement(CollectionPathwayInfoActionCardLoader_1.default, { isMobile: props.isMobile })) : (react_1.default.createElement(StyledCollectionPathwayInfoActionCard, { primaryColor: config.primaryColor, id: "collection-info-action-card", className: `${props.isMobile ? "mobile" : ""}`, key: `collection-info-action-card-${props.organization.id}` },
        react_1.default.createElement(react_toastify_1.ToastContainer, null),
        react_1.default.createElement("div", { className: "org-cont" },
            react_1.default.createElement("div", { className: `org-img-info ${props.organization.issuerProfile ? "crs-pnt" : ""}`, onClick: () => {
                    props.organization.issuerProfile && props.navigateToIssuerProfile();
                } },
                react_1.default.createElement("div", { className: "logo-wrapper" },
                    react_1.default.createElement("img", { src: props.organization.logoLink
                            ? props.organization.logoLink
                            : organization_svg_1.default, alt: "org-logo", className: "org-logo" }),
                    props.organization.isVerified && (react_1.default.createElement("img", { src: verified_issuer_mark_svg_1.default, alt: "verified-issuer-mark", className: "verified-issuer-mark" }))),
                react_1.default.createElement("div", { className: `flex-column ${props.organization.isVerified ? "jc-sb" : "jc-c"}  ai-fs` },
                    react_1.default.createElement("span", { className: "org-title" }, props.organization.name),
                    props.organization.isVerified && (react_1.default.createElement("span", { className: "org-verified-text" }, props.translate("verifiedIssuer").toString())))),
            props.organization.email && (react_1.default.createElement("div", { className: "org-action-container" },
                react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, width: 45, height: 29, className: "mail-btn", onClickAction: () => {
                        handleMailTo("contactIssuer");
                    } },
                    react_1.default.createElement("div", { className: "mail-btn-row" },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: mail_icon_svg_1.default, className: "customizable-icon mail-icon", wrapper: "svg", width: 15, height: 17 })))))),
        react_1.default.createElement("div", { className: "grey-divider" }),
        react_1.default.createElement("div", { className: "action-cont" },
            react_1.default.createElement("span", { className: "share-title" }, props.infoCardType === "collection"
                ? props.translate("shareThisCollection").toString()
                : props.translate("shareThisPathway").toString()),
            react_1.default.createElement("div", { className: "share-row" },
                react_1.default.createElement(react_linkedin_login_oauth2_1.LinkedIn, { clientId: "775jdov7xhw33h", redirectUri: (_a = props.linkedinRedirectUri) !== null && _a !== void 0 ? _a : `${window.location.origin}/en/linkedinRedir`, onSuccess: (code) => handleLinkedinShare(code), scope: "r_emailaddress r_liteprofile w_member_social", closePopupMessage: "Close Pop Up", onError: (error) => {
                        console.log(error);
                    } }, ({ linkedInLogin }) => (react_1.default.createElement("div", { className: "social-icon-container", onClick: linkedInLogin },
                    react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: linkedin_svg_1.default, className: "customizable-icon", wrapper: "svg", width: 15, height: 20 }))))),
                react_1.default.createElement(react_share_1.TwitterShareButton, { ref: twitterRef, onClick: () => handleClick("twitter"), title: handleDesc("twitter"), related: (0, ElementBaseConfig_1.getElementkitConfig)().twitterShareRelatedTags, url: props.shareUrl, className: "social-icon-container", openShareDialogOnClick: true },
                    react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: x_svg_1.default, className: "customizable-icon", key: "twitter-icon", wrapper: "svg", beforeInjection: (svg) => {
                                svg.setAttribute("width", "15px");
                                svg.setAttribute("height", "15px");
                            }, width: 14, height: 17 }))),
                react_1.default.createElement(react_share_1.FacebookShareButton, { ref: facebookRef, onClick: () => handleClick("facebook"), quote: handleDesc("facebook"), url: props.shareUrl, className: "social-icon-container", openShareDialogOnClick: true },
                    react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                        react_1.default.createElement(react_svg_1.ReactSVG, { src: facebook_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                svg.setAttribute("width", "8");
                                svg.setAttribute("height", "15");
                            }, width: 8, height: 17 }))),
                props.isMobile ? (react_1.default.createElement("div", { ref: moreRef, style: { width: "100%" } },
                    react_1.default.createElement("div", { className: "social-icon-container" },
                        react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => {
                                toggleShareDropdown();
                            } },
                            react_1.default.createElement(react_svg_1.ReactSVG, { src: three_dot_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                    svg.setAttribute("width", "20");
                                }, width: 20, height: 9 })),
                        shareDropdownOpen && (react_1.default.createElement("div", { className: "more-div" },
                            react_1.default.createElement("a", { ref: xingRef, onClick: () => handleClick("xing"), target: "_blank", href: `https://www.xing.com/spi/shares/new?url=${props.shareUrl}`, title: "Share on Xing", rel: "nofollow noopener noreferrer", className: "share-option" },
                                react_1.default.createElement("span", null, "Xing"),
                                react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                        svg.setAttribute("width", "12.84");
                                        svg.setAttribute("height", "15");
                                    }, width: 17, height: 17 })),
                            react_1.default.createElement(react_share_1.WhatsappShareButton, { ref: whatsappRef, onClick: () => handleClick("whatsapp"), title: handleDesc("whatsapp"), url: props.shareUrl, style: { width: "100%" }, openShareDialogOnClick: true, className: "share-option" },
                                react_1.default.createElement("span", null, "Whatsapp"),
                                react_1.default.createElement(react_svg_1.ReactSVG, { src: whatsapp_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                        svg.setAttribute("width", "18");
                                        svg.setAttribute("height", "18");
                                    }, width: 20, height: 19 })),
                            react_1.default.createElement("div", { ref: yammerRef, className: "share-option", onClick: shareOnYammer },
                                react_1.default.createElement("span", null, "Yammer"),
                                react_1.default.createElement(react_svg_1.ReactSVG, { src: yammer_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                        svg.setAttribute("width", "19.83");
                                        svg.setAttribute("height", "17");
                                    }, width: 19.83, height: 17 }))))))) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("a", { ref: xingRef, onClick: () => handleClick("xing"), target: "_blank", href: `https://www.xing.com/spi/shares/new?url=${props.shareUrl}`, title: "Share on Xing", rel: "nofollow noopener noreferrer", className: "social-icon-container" },
                        react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                            react_1.default.createElement(react_svg_1.ReactSVG, { src: xing_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                    svg.setAttribute("width", "12.84");
                                    svg.setAttribute("height", "15");
                                }, width: 12.84, height: 17 }))),
                    react_1.default.createElement(react_share_1.WhatsappShareButton, { ref: whatsappRef, onClick: () => handleClick("whatsapp"), title: handleDesc("whatsapp"), url: props.shareUrl, openShareDialogOnClick: true, className: "share-option" },
                        react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                            react_1.default.createElement(react_svg_1.ReactSVG, { src: whatsapp_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                    svg.setAttribute("width", "18");
                                    svg.setAttribute("height", "18");
                                }, width: 18, height: 19 }))),
                    react_1.default.createElement("div", { ref: yammerRef, className: "share-option", onClick: shareOnYammer },
                        react_1.default.createElement(BaseButton_1.default, { type: "secondary", size: "small", loading: false, height: 30, width: 60, onClickAction: () => { } },
                            react_1.default.createElement(react_svg_1.ReactSVG, { src: yammer_svg_1.default, className: "customizable-icon", wrapper: "svg", beforeInjection: (svg) => {
                                    svg.setAttribute("width", "19.83");
                                    svg.setAttribute("height", "17");
                                }, width: 19.83, height: 17 })))))))));
}
exports.default = CollectionPathwayInfoActionCard;
